import { ChairIcon } from "~/icons/ChairIcon";
import { DoorIcon } from "~/icons/DoorIcon";
import { PeopleIcon } from "~/icons/PeopleIcon";
import { BuildingIcon } from "~/icons/BuildingIcon";
import { ArrowSquareIcon } from "~/icons/ArrowSquareIcon";
import { OneStarIcon } from "~/icons/OneStarIcon";
import { Building2Icon } from "~/icons/Building2Icon";
import { SingleRoomIcon } from "~/icons/singleRoomIcon";
import { DoubleRoomIcon } from "~/icons/DoubleRoomIcon";
import { SharedRoomIcon } from "~/icons/SharedRoomIcon";
import { WifiIcon } from "~/icons/WifiIcon";
import { NoAccessIcon } from "~/icons/NoAccessIcon";
import { TwoStarsIcon } from "~/icons/TwoStarsIcon";
import { ThreeStarsIcon } from "~/icons/ThreeStarsIcon";
import { FourStarsIcon } from "~/icons/FourStarsIcon";
import { FiveStarsIcon } from "~/icons/FiveStarsIcon";

type HotelStats = {
  totalRooms: string;
  totalSingleRooms: string;
  totalDoubleRooms: string;
  totalSharedRooms: string;
  freeWifi: boolean;
  freeLan: boolean;
};

type HotelStatKey = keyof HotelStats;
const items: {
  icon: React.ReactNode;
  label: string;
  valueKey: HotelStatKey;
}[] = [
    {
      icon: <Building2Icon />,
      label: "Zimmer insgesamt",
      valueKey: "totalRooms",
    },
    {
      icon: <SingleRoomIcon />,
      label: "Einzelzimmer",
      valueKey: "totalSingleRooms",
    },
    {
      icon: <DoubleRoomIcon />,
      label: "Doppelzimmer",
      valueKey: "totalDoubleRooms",
    },
    {
      icon: <SharedRoomIcon />,
      label: "Mehrbettzimmer",
      valueKey: "totalSharedRooms",
    },
    {
      icon: <WifiIcon />,
      label: "kostenfrei",
      valueKey: "freeWifi",
    },
    {
      icon: <BuildingIcon />,
      label: "kostenfrei",
      valueKey: "freeLan",
    },
  ];

interface HotelDetailProps {
  classification: number;
  stats?: HotelStats;
}

export function HotelDetail({ classification, stats }: HotelDetailProps) {
  return (
    <div className="space-y-6">
      {stats ? (
        <div className="flex flex-wrap gap-8 py-4">
          {classification > 0 ? (
            <div className="w-[74px] h-[54px] rounded-md bg-gray-darker text-white hover:bg-gray-dark">
              {classification === 1 ? (
                <OneStarIcon />
              ) : classification === 2 ? (
                <TwoStarsIcon />
              ) : classification === 3 ? (
                <ThreeStarsIcon />
              ) : classification === 4 ? (
                <FourStarsIcon />
              ) : <FiveStarsIcon />}
            </div>
          ) : null}
          {items.map((item, index) => {
            const value = stats[item.valueKey];

            // Hide if value is 0 or falsy (for boolean values)
            if (
              (item.valueKey === "freeWifi" || item.valueKey === "freeLan") &&
              !value
            ) {
              return null;
            }

            // Hide if numeric value is 0
            if (
              typeof value === "string" &&
              (value === "0" || Number(value) === 0)
            ) {
              return null;
            }

            const displayValue =
              item.valueKey === "freeWifi"
                ? "WLAN"
                : item.valueKey === "freeLan"
                  ? "LAN"
                  : value;

            return (
              <div
                key={`${item.label}-${index}`}
                className="flex flex-col items-center justify-between text-center"
              >
                <div>
                  <div className="text-3xl flex justify-center [&>svg]:size-8">
                    {item.icon}
                  </div>
                  <div className="text-lg font-semibold">{displayValue}</div>
                </div>
                <div className="text-xs">{item.label}</div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
